<template>
  <div class="flex items-center">
    <div class="flex w-full bg-white rounded shadow">
      <litepie-datepicker
        class="relative px-6 py-3 w-full focus:shadow-outline"
        :formatter="formatter"
        :value="modelValue"
        style="border: 0px !important;"
        @update:model-value="(value) => $emit('update:modelValue', value.join(','))"
      />
    </div>
    <button class="ml-3 text-gray-500 hover:text-gray-700 focus:text-indigo-500 text-sm" type="button" @click="$emit('reset')">Reset</button>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    modelValue: String,
    maxWidth: {
      type: Number,
      default: 300,
    },
  },
  emits: ['update:modelValue', 'reset'],
  data() {
    return {
      formatter: {
        date: 'DD-MM-YYYY',
        month: 'MMM',
      },
    }
  },
}
</script>
